import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { AcceptProposedTimeContainer } = await import('./index');
    return {
        Component: AcceptProposedTimeContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
